var render = function render(){var _vm=this,_c=_vm._self._c;return _c('COverviewPageLayout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('COverviewPageHeaderRow',{attrs:{"page-title":_vm.localisation.title}})]},proxy:true},{key:"content",fn:function(){return [_c('div',{attrs:{"id":"cookiebotWrapper"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }